import type { ModelReasoningEffort } from '@openai/codex-sdk';

/** The installed SDK's wire values; picker choices come from model/list. */
export function codexEfforts() {
  return [
    'minimal',
    'low',
    'medium',
    'high',
    'xhigh',
    'max',
    'ultra',
    'persistent',
  ] as const satisfies readonly ModelReasoningEffort[];
}

export function isCodexEffort(value: unknown): value is ModelReasoningEffort {
  return typeof value === 'string' && codexEfforts().some((effort) => effort === value);
}

export type CodexModel = {
  model: string;
  displayName: string;
  description: string;
  defaultReasoningEffort: string;
  supportedReasoningEfforts: { reasoningEffort: ModelReasoningEffort; description: string }[];
};

export function codexEffortLabel(effort: string): string {
  if (effort === 'xhigh') return 'Extra high';
  return effort.charAt(0).toUpperCase() + effort.slice(1);
}
